export enum BetStateBitMask {
  InsufficientFunds = 0b00000001,
  Inactivity = 0b00000010,
  OtherBlockingPopup = 0b00000100,
  VideoSoundOn = 0b00001000,
  GameSoundOn = 0b00010000,
  VideoOn = 0b00100000,
}

export const updateBetStateBitMask = (bit: BetStateBitMask): void => {
  betStateBitMask |= bit;
};

export let betStateBitMask = 0;
